export class Product {
    public id!: number;
    public comment!: string;
    public imageOrigin!: string;
    public linkOrigin!: string;
    public priceOrigin!: number;
    public priceOriginVND!: number;
    public pricePromotion!: number;
    public pricePromotionVND!: number;
    public property!: string;
    public quantity!: number;
    public titleOrigin!: string;
    public amount!: number;
    public amountCN!: number;
    public dataValue!: string;
    public itemId!: string;
    public isChoose!: boolean;
}
